module.exports = __webpack_public_path__ + "img/psco6sv8c4w0b2celkhzmgawb37c0ct9cjr8abb4fba-5ff4-4329-864d-0e67e9e8202a.ea75180e.png";